import {
    FiAlertCircle,
    FiAperture,
    FiBook,
    FiBookmark,
    FiBox,
    FiBriefcase,
    FiCheckCircle,
    FiCoffee,
    FiHeart,
    FiInstagram,
    FiMail,
    FiMessageCircle,
    FiPenTool,
    FiSend,
    FiShoppingBag,
    FiSmile,
    FiStar,
    FiSun,
    FiUser,
    FiUserCheck,
    FiUsers,
    FiYoutube
} from "react-icons/fi";

import team4 from '../assets/images/team/Agnes.jpeg';
import team5 from '../assets/images/team/Allan.jpeg';
import team1 from '../assets/images/team/Esther.jpeg';
import team10 from '../assets/images/team/Evelyn.jpeg';
import team6 from '../assets/images/team/Harriet.jpeg';
import team3 from '../assets/images/team/Isaac.jpeg';
import team11 from '../assets/images/team/Morris.jpeg';
import team13 from '../assets/images/team/nalumagaAgnes.jpeg';
import team7 from '../assets/images/team/paul.jpeg';
import team12 from '../assets/images/team/Pusha.jpeg';
import team14 from '../assets/images/team/rachel.jpeg';
import team8 from '../assets/images/team/Sharon_Wogi.jpeg';
import team2 from '../assets/images/team/Sheeba.jpeg';
// import team15 from '../assets/images/team/7.jpeg'
import team16 from '../assets/images/team/Mellan.jpeg';
// import avatar_female from '../assets/images/team/avatar_female.jpeg'
// import avatar_male from '../assets/images/team/avatar_male.png'

import blog1 from '../assets/images/blog/1.jpeg';
import blog2 from '../assets/images/blog/2.jpeg';
import blog3 from '../assets/images/blog/3.jpeg';
import blogX from '../assets/images/blog/blogX.jpeg';
import blogXEsther from '../assets/images/blog/blogXEst.jpeg';

import causes3 from '../assets/images/about/1.jpg';
import causes1 from '../assets/images/cause/pic1.jpeg';
import causes5 from '../assets/images/cause/pic10.jpeg';
import causes6 from '../assets/images/cause/pic12.jpeg';
import causes4 from '../assets/images/cause/pic2.jpeg';
import causes2 from '../assets/images/cause/pic9.jpeg';

import gallery1 from "../assets/images/gallery/1.jpeg";
import gallery2 from "../assets/images/gallery/2.jpeg";
import gallery3 from "../assets/images/gallery/3.jpeg";

import hero1 from "../assets/images/hero/1.jpg";
import hero2 from "../assets/images/hero/2.jpg";
import hero3 from "../assets/images/hero/3.jpg";

export const featureData = [{
        icon: FiAperture,
        title: 'Breakfast Programme',
        desc: "Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
    {
        icon: FiSend,
        title: 'Food Assistance',
        desc: "Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
    {
        icon: FiUser,
        title: 'Social Works',
        desc: "Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
    {
        icon: FiStar,
        title: 'Digital Education',
        desc: "Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
    {
        icon: FiBookmark,
        title: 'Scholarship Programme',
        desc: "Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
    {
        icon: FiMessageCircle,
        title: 'School Programme',
        desc: "Success needs hard work. Don't listen to these 'get rich quick' schemes."
    },
]

export const clientData = [{
        image: team1,
        name: 'Calvin Carlo',
        position: 'Manager',
        desc: "According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero Launch your campaign and benefit from our expertise",
        tag: 'Creativity',
        rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star']
    },
    {
        image: team2,
        name: 'Carl Oliver',
        position: 'Manager',
        desc: "I didn't know a thing about icon design until I read this book. Now I can create any icon I need in no time. Great resource!",
        tag: 'Modern',
        rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star']
    },
    {
        image: team3,
        name: 'Barbara McIntosh',
        position: 'Manager',
        desc: "The best part about Flipup is every time I pay my employees, my bank balance doesn't go down like it used to. Looking forward to spending this extra cash when I figure out why my card is being declined.",
        tag: 'Social Marketing',
        rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star']
    },
    {
        image: team4,
        name: 'Janisha Doll',
        position: 'Manager',
        desc: "I used to have to remit tax to the EU and with Flipup I somehow don't have to do that anymore. Nervous to travel there now though",
        tag: 'Digital Marketing',
        rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star']
    },
    {
        image: team5,
        name: 'Esther Howard',
        position: 'Manager',
        desc: "There are so many things I had to do with my old software that I just don't do at all with Flipup. Suspicious but I can't say I don't love it",
        tag: 'SEO',
        rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star']
    },
    {
        image: team6,
        name: 'Joshua William',
        position: 'Manager',
        desc: "I'm trying to get a hold of someone in support, I'm in a lot of trouble right now and they are saying it has something to do with my books. Please get back to me right away.",
        tag: 'Classic',
        rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star']
    },
    {
        image: team7,
        name: 'Thomas Israel',
        position: 'Manager',
        desc: "This is the fourth email I've sent to your support team. I am literally being held in jail for tax fraud. Please answer your damn emails, this is important. ",
        tag: 'Features',
        rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star']
    },
    {
        image: team8,
        name: 'Jill Webb',
        position: 'Manager',
        desc: "I used to have to remit tax to the EU and with Flipup I somehow don't have to do that anymore. Nervous to travel there now though. ",
        tag: 'Branding',
        rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star']
    },
    {
        image: team2,
        name: 'Jennifer White',
        position: 'Manager',
        desc: "The team is exceptional. Their passion for what they do is evident in the results they deliver. We're grateful to have them as a trusted partner in our journey. ",
        tag: 'Product Design',
        rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star']
    },
]

export const blogData = [{
        id: 1,
        url: 'message-from-founder',
        image: team1,
        tag: 'Tu Es Belle',
        title: 'Message From the Founder',
        desc: "Growing up as a child there was always a thymos for a-lot of things happening that I didn't have the power to change.",
        date: '13th Sept 2024'
    },
    {
        id: 2,
        url: 'faith-into-enterprise-daily-monitor',
        image: blogX,
        tag: 'Press Feature',
        type: 'press',
        title: 'How Local Foundation Has Assisted Residents Turn Faith into Enterprise',
        desc: 'Daily Monitor covers how Tu Es Belle Foundation is helping community members transform their faith into sustainable livelihoods.',
        date: '2025',
        source: 'Daily Monitor',
        externalUrl: 'https://www.monitor.co.ug/uganda/news/national/how-local-foundation-has-assisted-residents-turn-faith-into-enterprise-5419442',
        tweetUrl: 'https://twitter.com/dailymonitor/status/2042837733672984676',
        tweetId: '2042837733672984676',
    },
    {
        id: 3,
        url: 'understand-share-feelings-daily-monitor',
        image: blogXEsther,
        tag: 'Press Feature',
        type: 'press',
        title: '"We Ought to Understand, Share the Feelings of Another"',
        desc: 'Daily Monitor profiles Esther Namukwaya Yawe Ntwatwa on empathy, community leadership and the mission behind Tu Es Belle.',
        date: '2025',
        source: 'Daily Monitor',
        externalUrl: 'https://www.monitor.co.ug/uganda/lifestyle/reviews-profiles/-we-ought-to-understand-share-feelings-of-another--5445532',
        tweetUrl: 'https://twitter.com/dailymonitor/status/2051074327953723474',
        tweetId: '2051074327953723474',
    },
]

export const footerSocial = [{
        icon: FiMail,
        link: 'mailto:tuesbelleus@gmail.com'
    },
    {
        icon: FiYoutube,
        link: 'https://www.youtube.com/@2esbelleorg'
    },
    // {
    //     icon:FiFacebook,
    //     link:'#'
    // },
    {
        icon: FiInstagram,
        link: 'https://www.instagram.com/_2esbelle/'
    },
    // {
    //     icon:FiTwitter,
    //     link:'#'
    // },
]

export const footerCompany = [{
        title: 'About us',
        link: '/aboutus'
    },
    {
        title: 'Services',
        link: '/services'
    },
    {
        title: 'Team',
        link: '/team'
    },
    // {
    //     title:'Pricing',
    //     link:'/pricing'
    // },
    {
        title: 'Blog',
        link: '/blogs'
    },
    // {
    //     title:'Login',
    //     link:'/login'
    // },
]

export const footerLink = [{
        title: 'Helpcenter',
        link: '/faqs'
    },
    {
        title: 'Terms of Services',
        link: '/terms'
    },
    {
        title: 'Privacy Policy',
        link: '/privacy'
    },
]

export const footerLink2 = [
    'Privacy', 'Terms', 'FAQs', 'Contact'
]

export const counterData = [{
        icon: FiCheckCircle,
        title: 'Project Completed',
        value: '49'
    },
    {
        icon: FiCoffee,
        title: 'Cup of Coffee',
        value: '2461'
    },
    {
        icon: FiUserCheck,
        title: 'Client Satisfaction',
        value: '99'
    },
    {
        icon: FiBox,
        title: 'Country Offices',
        value: '49'
    },
]

export const teamData = [
    // board
    {
        image: team1,
        name: 'Miss. Esther Yawe Ntwatwa',
        position: 'Founder',
        social: [FiInstagram],
        instaLink: 'https://www.instagram.com/estheryawentwatwa/'
    },
    {
        image: team2,
        name: 'Mrs. Sheeba Kakuba',
        position: 'Co-founder',
        social: [FiInstagram],
        instaLink: 'https://www.instagram.com/'
    },
    {
        image: team4,
        name: 'Miss. Agnes Namugere',
        position: 'Co-founder',
        social: [FiInstagram],
        instaLink: 'https://www.instagram.com/faith_aggie'
    },
    {
        image: team3,
        name: 'Mr. Isaac Ddumba',
        position: 'Board Member',
        social: [FiInstagram],
        instaLink: 'https://www.instagram.com/pastor_isaac_dumba'
    },
    {
        image: team5,
        name: 'Mr. Allan Kiyemba',
        position: 'Board Member',
        social: [FiInstagram],
        instaLink: 'https://www.instagram.com/'
    },
    {
        image: team6,
        name: 'Miss. Harriet Kawanguzi',
        position: 'Board Member',
        social: [FiInstagram],
        instaLink: 'https://www.instagram.com/harriet.racheal'
    },
    {
        image: team7,
        name: 'Mr. Paul Yawe',
        position: 'Board Member',
        social: [FiInstagram],
        instaLink: 'https://www.instagram.com/paulyawe2020'
    },
    {
        image: team16,
        name: 'Miss. Mellan Mugayo',
        position: 'Board Member',
        social: [FiInstagram],
        instaLink: ''
    },

    // CFO && COO
    {
        image: team8,
        name: 'Mrs. Sharon Wogi',
        position: 'CFO',
        social: [FiInstagram],
        instaLink: ''
    },

    // Departments
    {
        image: team10,
        name: 'Miss. Evelyn Love Namulinda',
        position: 'Fundraising and development',
        social: [FiInstagram],
        instaLink: ''
    },
    {
        image: team11,
        name: 'Mr Morris Kakooza',
        position: 'Programs and Services',
        social: [FiInstagram],
        instaLink: ''
    },
    {
        image: team12,
        name: 'Mr. Pusha',
        position: 'Marketing and communications',
        social: [FiInstagram],
        instaLink: ''
    },
    {
        image: team13,
        name: 'Miss. Nalumaga Agnes',
        position: 'Human Resource and administration',
        social: [FiInstagram],
        instaLink: ''
    },
    {
        image: team14,
        name: 'Miss. Rachel',
        position: 'Volunteer cordinator',
        social: [FiInstagram],
        instaLink: ''
    },
    // {
    //     image:team15,
    //     name:'Mr Isaac Ddumba',
    //     position:'Coperate partnerships',
    //     social:[FiInstagram]
    // },
]

export const galleryData = [{
        id: 1,
        type: "image",
        src: gallery1,
        title: "Community Outreach",
    },
    {
        id: 2,
        type: "image",
        src: gallery2,
        title: "Women Empowerment Workshop",
    },
    {
        id: 3,
        type: "image",
        src: gallery3,
        title: "Women Empowerment Workshop",
    },
    // {
    //     id: 3,
    //     type: "video",
    //     src: "https://www.youtube.com/embed/4r3MZNCGzVY",
    //     thumbnail: gallery3,
    //     title: "Foundation Highlights",
    // },
    {
        id: 4,
        type: "image",
        src: causes1,
        title: "Women Empowerment Workshop",
    },
    {
        id: 4,
        type: "image",
        src: causes2,
        title: "Women Empowerment Workshop",
    },
    {
        id: 5,
        type: "image",
        src: causes3,
        title: "Women Empowerment Workshop",
    },
    {
        id: 6,
        type: "image",
        src: causes4,
        title: "Women Empowerment Workshop",
    },
    {
        id: 7,
        type: "image",
        src: causes5,
        title: "Women Empowerment Workshop",
    },
    {
        id: 8,
        type: "image",
        src: causes6,
        title: "Women Empowerment Workshop",
    },
    {
        id: 9,
        type: "image",
        src: hero1,
        title: "Women Empowerment Workshop",
    },
    {
        id: 10,
        type: "image",
        src: hero2,
        title: "Women Empowerment Workshop",
    },
    {
        id: 11,
        type: "image",
        src: hero3,
        title: "Women Empowerment Workshop",
    }
];

export const servicesData = [{
        icon: FiSun,
        title: 'Personal Empowerment',
        desc: "We enhance self-confidence and self-esteem through workshops, leadership programs, and group discussions, helping women recognize their worth and embrace their potential."
    },
    {
        icon: FiBook,
        title: 'Educational Empowerment',
        desc: "We support school dropouts and disadvantaged women with literacy programs, computer training, and business courses to help them secure brighter futures."
    },
    {
        icon: FiBriefcase,
        title: 'Financial Empowerment',
        desc: "We train women in practical skills like crafts, baking, etiquette, soap-making, and makeup artistry, enabling them to start businesses and achieve financial independence."
    },
    {
        icon: FiHeart,
        title: 'Moral Empowerment',
        desc: "We promote ethics and values through workshops that address societal challenges, fostering integrity and positive change in communities."
    },
    {
        icon: FiAlertCircle,
        title: 'Social Justice Advocacy',
        desc: "We advocate for women’s rights, supporting victims of violence, single mothers, and oppressed women through outreach programs and resources."
    },
    {
        icon: FiShoppingBag,
        title: 'Income-Generating Products',
        desc: "We produce and sell items like hair oil, lip gloss, scented candles, and bags, providing women with skills and income while sustaining the foundation."
    },
    {
        icon: FiSmile,
        title: 'Physiological Empowerment',
        desc: "We provide counseling and therapy to victims of abuse, offering safe spaces for healing and emotional recovery through individual and group sessions."
    },
    {
        icon: FiPenTool,
        title: 'Creative Arts Empowerment',
        desc: "We nurture creativity by teaching music, art, knitting, and crafts, helping women express themselves while developing marketable skills."
    },
    {
        icon: FiUsers,
        title: 'Community Building',
        desc: "We connect women with mentors and foster supportive communities, encouraging peer learning, shared growth, and long-term empowerment."
    },
]

export const faqData = [{
        id: 1,
        category: 'general',
        title: 'What is the mission of Tu Es Belle Foundation?',
        desc: 'To empower women and girls by enhancing their self-worth, providing access to education and resources, and enabling them to make independent decisions for their lives.'
    },
    {
        id: 2,
        category: 'general',
        title: 'What is the vision of Tu Es Belle Foundation?',
        desc: 'We envision a world free of poverty, where women are empowered mentally, emotionally, and spiritually to live in safe and sustainable environments.'
    },
    {
        id: 3,
        category: 'general',
        title: ' Who does Tu Es Belle Foundation aim to support?',
        desc: 'We support rape victims, victims of violence, school dropouts, oppressed women, and single or teen mothers.'
    },
    {
        id: 4,
        category: 'general',
        title: 'What does the name "Tu Es Belle" mean?',
        desc: '"Tu Es Belle" means "You are Beautiful" in French, reflecting the foundation’s mission to remind women of their worth.'
    },
    // Education and Empowerment
    {
        id: 5,
        category: 'education',
        title: 'Why does Tu Es Belle prioritize education for girls?',
        desc: ' Education is key to breaking generational poverty and empowering women to contribute meaningfully to society.'
    },
    {
        id: 6,
        category: 'education',
        title: "What skills are taught through the foundation's programs?",
        desc: 'Skills include arts and crafts, business training, computer lessons, baking, knitting, etiquette, and more.'
    },
    {
        id: 7,
        category: 'education',
        title: 'How does the foundation empower women mentally and emotionally?',
        desc: 'Through confidence-building, counseling, and creating safe spaces for women to express themselves and grow.'
    },
    {
        id: 8,
        category: 'education',
        title: "What is the role of spiritual empowerment in the foundation's mission?",
        desc: 'It helps women find inner strength and purpose by emphasizing faith and moral education.'
    },

    // Social Impact
    {
        id: 9,
        category: 'social',
        title: 'How does Tu Es Belle address social injustice?',
        desc: 'By empowering women to overcome gender-based discrimination, violence, and oppression, fostering a more equitable society.'
    },
    {
        id: 10,
        category: 'social',
        title: 'How does the foundation support victims of abuse?',
        desc: 'Through counseling, therapy, and empowerment programs to rebuild their confidence and independence.'
    },
    {
        id: 11,
        category: 'social',
        title: 'What impact does female empowerment have on communities?',
        desc: 'Empowered women uplift families and communities, fostering social and economic growth.'
    },
    {
        id: 12,
        category: 'social',
        title: 'Why does the foundation focus on single and teen mothers?',
        desc: 'To provide them with skills, education, and emotional support to secure a brighter future for themselves and their children.'
    },

    // Supporting the Foundation
    {
        id: 13,
        category: 'support',
        title: 'What products does the foundation sell to sustain its programs?',
        desc: 'Products include hair oil, lip gloss, scented candles, bags, and other lady essentials.'
    },
    {
        id: 14,
        category: 'support',
        title: 'How can individuals support the foundation’s mission?',
        desc: 'By purchasing products, volunteering, or donating to help fund programs and initiatives.'
    },
    {
        id: 15,
        category: 'support',
        title: 'Can I volunteer with Tu Es Belle Foundation?',
        desc: 'Yes, the foundation welcomes volunteers to contribute their time and skills to empower women and girls.'
    },
    {
        id: 16,
        category: 'support',
        title: "Where do the proceeds from the foundation's products go?",
        desc: 'All proceeds are used to support empowerment programs, training, and resources for women and girls.'
    },
]

export const recentPost = [{
        image: blog1,
        title: 'Why Educating Women is the Key to a Better Future',
        date: '13th March 2024'
    },
    {
        image: blog2,
        title: 'Tu Es Belle: Where Aspiration Meets Action',
        date: '5th May 2024'
    },
    {
        image: blog3,
        title: 'The Power of Education: Building a Stronger Nation Through Women',
        date: '19th June 2024'
    },
    {
        image: blog3,
        title: 'From Inequality to Inspiration: How Tu Es Belle is Changing Lives',
        date: '19th June 2024'
    },
    {
        image: blog3,
        title: 'Empowered Women, Empowered Generations: The Vision of Tu Es Belle',
        date: '19th June 2024'
    },
    {
        image: blog3,
        title: 'Transforming Lives: The Role of Skills Training in Women’s Empowerment',
        date: '19th June 2024'
    },
]

export const tagCloud = [
    '#WomenEmpowerment', '#EducationForAll', '#EqualityMatters', '#BreakingBarriers', '#Inspiration', '#FemaleLeadership', '#CommunityImpact', '#FutureOfWomen', '#MentalAndSpiritualGrowth', '#TuEsBelleFoundation',
]

export const tearmsData = [
    'Digital Marketing Solutions for Tomorrow', 'Our Talented & Experienced Marketing Agency', 'Create your own skin to match your brand', 'Digital Marketing Solutions for Tomorrow', 'Our Talented & Experienced Marketing Agency', 'Create your own skin to match your brand'
]

export const causesData = [{
        image: causes1,
        title: 'Empowering Women and Girls',
        desc: 'We help women discover their self-worth and confidence through education, training, and skill-building.'
    },
    {
        image: causes2,
        title: 'Education Opportunities',
        desc: 'We advocate for equal access to education, ensuring every girl has the opportunity to thrive.'
    },
    {
        image: causes3,
        title: 'Support for Vulnerable Women',
        desc: 'We create safe spaces for single mothers, teen mothers, and school dropouts to rebuild their lives.'
    },
    {
        image: causes4,
        title: 'Skill Development Programs',
        desc: 'We offer specialized training in hair dressing and make up, baking, soap making, crafts making, tailoring, computer lessons, and etiquette to broaden opportunities.'
    },
    {
        image: causes5,
        title: 'Sustainable Initiatives',
        desc: "We produce goods like hair oil, lip gloss, scented candles, and bags to support our foundation's programs."
    },
    {
        image: causes6,
        title: 'Community Development',
        desc: 'We strive change societal structures to eliminate gender-based discrimination and inequality, creating a brighter future.'
    },
]